import { create } from "zustand";
import { persist, PersistOptions } from "zustand/middleware";
import axios from "axios";

// Définition du type du store
interface AuthState {
    token: string | null;
    refreshToken: string | null;
    setAuthTokens: (token: string, refreshToken: string) => void;
    refreshAccessToken: () => Promise<string | null>;
    clearAuthTokens: () => void;
}

// Options de persistance pour Zustand
// @ts-ignore
const persistOptions: PersistOptions<AuthState> = {
    name: "auth-storage", // Clé utilisée dans sessionStorage
    storage: {
        // @ts-ignore
        getItem: (key) => sessionStorage.getItem(key),
        // @ts-ignore
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: (key) => sessionStorage.removeItem(key),
    },
};

const useAuthStore = create<AuthState>()(
    persist(
        (set,get) => ({
            token: null,
            refreshToken: null,
            setAuthTokens: (token: string, refreshToken: string) => set({ token, refreshToken }),
            refreshAccessToken: async () => {
                try {
                    const { refreshToken } = get();
                    if (!refreshToken) return null;

                    const response = await axios.post('/api/refresh-token', { refreshToken });
                    const { token: newAccessToken, refreshToken: newRefreshToken } = response.data;

                    set({
                        token: newAccessToken,
                        refreshToken: newRefreshToken || refreshToken
                    });

                    return newAccessToken;
                } catch (error) {
                    console.error('Erreur de refresh token', error);
                    get().clearAuthTokens();
                    return null;
                }
            },
            clearAuthTokens: () => set({ token: null, refreshToken: null }),
        }),
        persistOptions
    )
);

export default useAuthStore;
